import qs from 'qs';
import { meissaApi } from '../modules/maps';
import TileLayer from 'ol/layer/Tile';
import { XYZ } from 'ol/source';

export const safObjectHelper = {
  mapDataToStr(locationJson: any) {
    if (!locationJson) {
      str = '';
      return str;
    }
    var extent = locationJson.extent;
    var points = locationJson.points;
    if (!extent || extent.length === 0) {
      str = '';
      return str;
    }
    var str;
    if (!points || points.length === 0) {
      const formattedExtent = extent.map((num: any) => num.toFixed(3)).join(', ');
      str = `Extent: [${formattedExtent}] | No points found`;
      return str;
    }
    const formattedExtent = extent.map((num: any) => num.toFixed(3)).join(', ');
    str = `Extent: [${formattedExtent}] | ${points.length} points visible`;
    return str;
  },
  isPlainObject(val: any) {
    return val !== null && typeof val === 'object' && val.constructor === Object;
  },
  isCollection(val: any) {
    return (
      val !== null && typeof val === 'object' && (val.constructor === Object || Array.isArray(val))
    );
  },
  isJsonObject(val: any) {
    var p1 = this.isPlainObject(val);
    var p2 = this.isCollection(val);
    return p1 || p2;
  },
  clone(original: any) {
    const clone = structuredClone(original);
    return clone;
  },
  formatDate(dateObj: any) {
    //console.log(dateObj);
    if (dateObj) {
      var d: any;
      if (dateObj instanceof Date) {
        d = dateObj;
      } else {
        var dateObj = dateObj.split('+')[0];
        d = new Date(dateObj);
      }
      if (d) {
        const day = String(d.getDate()).padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(d);
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      } else {
        return ' ';
      }
    } else {
      return ' ';
    }
  },
  formatTime(dateObj: any) {
    if (dateObj) {
      var d: any;
      if (dateObj instanceof Date) {
        d = dateObj;
      } else {
        var dateObj = dateObj.split('+')[0];
        d = new Date(dateObj);
      }
      if (d) {
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
      } else {
        return ' ';
      }
    } else {
      return ' ';
    }
  },
  formatDateTime(dateObj: any) {
    if (dateObj) {
      var d: any;
      if (dateObj instanceof Date) {
        d = dateObj;
      } else {
        var dateObj = dateObj.split('+')[0];
        d = new Date(dateObj);
      }
      if (d) {
        const day = String(d.getDate()).padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(d);
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}`;
      } else {
        return ' ';
      }
    } else {
      return ' ';
    }
  },
  formatTimeDifference(dateObj1: any, dateObj2: any) {
    if (dateObj1 && dateObj2) {
      var d1: any;
      if (dateObj1 instanceof Date) {
        d1 = dateObj1;
      } else {
        var dateObj1 = dateObj1.split('+')[0];
        d1 = new Date(dateObj1);
      }
      var d2: any;
      if (dateObj2 instanceof Date) {
        d2 = dateObj2;
      } else {
        var dateObj2 = dateObj2.split('+')[0];
        d2 = new Date(dateObj2);
      }
      if (d1 && d2) {
        const diffInMs = Math.abs(d1 - d2);
        const hours = Math.floor(diffInMs / (1000 * 60 * 60));
        const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
        if (hours > 0) {
          if (minutes > 0) {
            return `${hours}h ${minutes}m`;
          }
          return `${hours}h`;
        }
        return `${minutes}m`;
      } else {
        return ' ';
      }
    } else {
      return ' ';
    }
  },
  totalManPower(datas: any) {
    if (!datas || datas.length === 0) {
      return ' ';
    }
    var total = 0;
    for (var i in datas) {
      var data = datas[i];
      if (data.manPower1) {
        total += +data.manPower2;
      }
    }
    return total.toLocaleString('en-US');
  },
  calcManPower(datas: any, label: any, options: any) {
    if (!datas || datas.length === 0) {
      return ' ';
    }
    var sum = 0;
    for (var i in datas) {
      var data = datas[i];
      if (data.manPower1) {
        var find = false;
        for (var j in options) {
          var option = options[j];
          if (data.manPower1 === option.value && label === option.label) {
            find = true;
          }
        }
        if (find) {
          sum += +data.manPower2;
        }
      }
    }
    return sum.toLocaleString('en-US');
  },
  addMeissaMap(getSnapshotList: any, getOrthophoto: any, setTokens: any, map: any, order: number) {
    //return;
    meissaApi.token().then((tokenData: any) => {
      const { access, refresh, projectId } = tokenData.resultObject;
      setTokens(access, refresh);
      getSnapshotList(projectId).then((snapshotList: any) => {
        const filteredSnapshots = snapshotList.results.filter(
            (item: any) => item.data_process_history === 'DONE' && !!item.orthophoto_thumbnail
        );
        getOrthophoto(filteredSnapshots[0].id)
          .then((res: any) => {
            const { conversion_data } = res;
            const { meta } = conversion_data;
            const { tile_map, zoom_level } = meta;
            const { tile_format } = tile_map;
            const cartaTmsLayer = new TileLayer({
              source: new XYZ({
                tileUrlFunction: ([z, x, y]) => {
                  const tmsY = (1 << z) - y - 1;
                  return `/v1/api/map/proxy/carta/${conversion_data.root_path}${z}/${x}/${tmsY}.${tile_format.extension}`;
                  //https://cs.carta.is/carta/workspace/1791/36187/universal/orthophoto/16/51730/33013.png?
                  //return `https://cs.carta.is/carta/${conversion_data.root_path}${z}/${x}/${tmsY}.${tile_format.extension}?`;
                },
                minZoom: 1,
                maxZoom: 22
              })
            });
            map.getLayers().insertAt(order, cartaTmsLayer);
          })
          .catch((error: any) => {
            console.error('Failed to fetch orthophoto:', error);
          });
      });
    });
  }
};
